import Col from "../element/col";
import Row from "../element/row";
import Container from "../element/container";
import Lottie from "lottie-react";
import { Loading } from "../../assets/lotties";

export default function CommonLoading({ className }) {
  return (
    <Container className={`common-loading ${className ?? ""}`}>
      <Row className="lottie-frame">
        <Lottie animationData={Loading} />
      </Row>
      <Col className="v-flex gap-5 text-center">
        <h4>We are currently processing your payment.</h4>
        <p>
          Please <span>DO NOT</span> close this page or press refresh or back
          button.
        </p>
      </Col>
    </Container>
  );
}
